import axios from 'axios';
import Env from '~/env';
import { LocalStorage } from '~/storage/LocalStorage';
import { INSURANCE_AUTH_KEY } from '~/storage/constants';
import { getAssegurouTokenUseCase } from '~/useCases/AssegurouUseCases/GetTokenUseCase';
const ASSEGUROU_URL = Env.INSURANCE_URL;

const apiAssegurou = axios.create({
  baseURL: `${ASSEGUROU_URL}`,
});

apiAssegurou.interceptors.request.use(async (config) => {
  const token = await getAssegurouTokenUseCase();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiAssegurou.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await LocalStorage.remove(INSURANCE_AUTH_KEY);
      return apiAssegurou.request(error.config);
    }

    return Promise.reject(error);
  }
);

export default apiAssegurou;
